import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost
} from "./_wsApiFetchData";

export async function searchPurchase(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    productId, reference, purchaseId, status, userId, beforeAt, afterAt, orderBy, orderDirection
  } = filters;

  const params = {
    Number: skipPages || 1,
    Count: resultsCount || 20,
    UserId: userId || undefined,
    Status: status || undefined,
    PurchaseId: purchaseId || undefined,
    ProductId: productId || undefined,
    Reference: reference || undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined,
    // Both optional. Absent, the endpoint answers what it always has — newest
    // first by creation — so the old admin's request is unchanged.
    OrderBy: orderBy || undefined,
    OrderDirection: orderDirection || undefined
  };

  return toPascal(await wsRequestPost('/admin/purchases/search', language, timeZone, params, null, cancelToken));
}

export async function changeCourt(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const { productId, reference, purchaseId, status, userId, beforeAt, afterAt } = filters;

  const params = {
    Number: skipPages || 1,
    Count: resultsCount || 20,
    UserId: userId || undefined,
    Status: status || undefined,
    PurchaseId: purchaseId || undefined,
    ProductId: productId || undefined,
    Reference: reference || undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined
  };

  return toPascal(await wsRequestPost('/public/purchases/search', language, timeZone, params, null, cancelToken));
}

export async function getPurchase(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/purchases/${id}`, language, timeZone, null, cancelToken));
}

export async function getPurchaseProduct(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/purchases/purchaseproduct/${id}`, language, timeZone, null, cancelToken));
}

export async function searchParticipants(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const { purchaseProductId } = filters;

  const params = {
    Number: skipPages || 1,
    Count: resultsCount,
    PurchaseProductId: purchaseProductId
  };

  return toPascal(await wsRequestGet(`/admin/purchases/purchaseproduct/${purchaseProductId}/participants`, language, timeZone, params, cancelToken));
}

export async function searchFields(options, language, timeZone, cancelToken) {
  const { filters } = options;
  const { purchaseProductId } = filters;

  return toPascal(await wsRequestGet(`/admin/purchases/purchaseproduct/${purchaseProductId}/fields`, language, timeZone, null, cancelToken));
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
